import {useAuthUserStore} from "@/stores/auth";

export default {
    update(data)
    {
        return useAuthUserStore().getApiClient.put('/user/password', data)
    }
}